import { RefreshCw } from "lucide-react";

import { Button } from "@/components/button";
import { Dialog, DialogCloseButton } from "@/components/dialog";
import { Modal } from "@/components/modal";

type DiscardBriefDialogProps = {
  isDiscarding?: boolean;
  isOpen: boolean;
  onConfirm: () => void;
  onOpenChange: (isOpen: boolean) => void;
};

export function DiscardBriefDialog({
  isDiscarding = false,
  isOpen,
  onConfirm,
  onOpenChange,
}: DiscardBriefDialogProps) {
  return (
    <Modal
      classNames={{ modal: "w-[420px] max-w-[calc(100vw-32px)]" }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog alert className="p-6">
        <DialogCloseButton />

        <span className="flex size-11 items-center justify-center rounded-full bg-utility-error-50 text-text-error-primary">
          <RefreshCw className="size-5" />
        </span>

        <h2 className="mt-4 text-lg font-semibold text-text-primary">
          Switch to Classic Brief Form?
        </h2>
        <p className="mt-1 text-sm text-text-tertiary">
          Your current brief and chat will be discarded and you&apos;ll continue
          in the Classic Brief Form. This can&apos;t be undone.
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <Button
            className="flex-1"
            isDisabled={isDiscarding}
            onPress={() => onOpenChange(false)}
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            className="flex-1"
            color="destructive"
            isDisabled={isDiscarding}
            isLoading={isDiscarding}
            onPress={onConfirm}
            variant="primary"
          >
            Discard &amp; switch
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
}
